import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ListPickerModule } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker.module";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { BHRListViewComponent } from "./bhrList/bhr-list-view.component";
import { CountryListViewComponent } from "./countryList/country-list-view.component";
import { HolidayViewComponent } from "./holidayList/holiday-list-view.component";
import { PageRuleViewComponent } from "./pageRules/page-rule-view.component";
import { RepListViewComponent } from "./repList/rep-list-view.component";
import { TopicViewRoutingModule } from "./topic-view-routing.module";
import { VideoCheckboxViewComponent } from "./videoCheckbox/video-checkbox-view.component";
import { SaysoTopicViewComponent } from "./sayso-topic-view.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TopicViewRoutingModule,
    MaterialModule,
    TranslateModule,
    ListPickerModule
  ],
  declarations: [
    SaysoTopicViewComponent,
    RepListViewComponent,
    PageRuleViewComponent,
    HolidayViewComponent,
    CountryListViewComponent,
    BHRListViewComponent,
    VideoCheckboxViewComponent
  ]
})
export class TopicViewModule {}
